<div class="pages-body login-page p-d-flex p-flex-column">
    <p-toast key="tst"></p-toast>
    <div class="p-as-center p-mt-auto p-mb-auto">
        <p-messages [value]="msgs"></p-messages>
        <br/>
        <div class="pages-panel card p-d-flex p-flex-column">
            <div class="pages-header p-px-3 p-py-1">
                <!-- <h2>LOGIN</h2>-->
                <img id="app-logo" src="assets/layout/images/logo-manager-3.svg" alt="manager-layout" style="height: 2.25rem">
            </div>

            <h4>{{ 'label.bemvindo' | translate }}</h4>

            <!-- <div class="pages-detail p-mb-6 p-px-6">Please use the form to sign-in Manager network</div> -->

            <div class="input-panel p-d-flex p-flex-column p-px-3">
                <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-envelope"></i>
                    </span>
                    <span class="p-float-label">
                        <input type="text" id="email" pInputText [(ngModel)]="loginRequest.username" required autofocus>
                        <label for="email">{{ 'label.email' | translate }}</label>
                    </span>
                </div>

                <div class="p-inputgroup p-mt-3 p-mb-6">
                    <span class="p-inputgroup-addon">
                        <i class="pi pi-lock"></i>
                    </span>
                    <span class="p-float-label">
                        <input type="password" id="password" pInputText [(ngModel)]="loginRequest.password" required autofocus>
                        <label for="password">{{ 'label.password' | translate }}</label>
                    </span>
                </div>
                <p-button label="Esqueci minha senha" styleClass="p-button-link" (click)="openDialog()"></p-button>
            </div>
            <!--div class="card">
                <p-captcha siteKey="6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI" (onResponse)="showResponse($event)"></p-captcha>
            </div-->
            <p-button class="login-button p-mb-6 p-px-3" label="LOGIN" (click)="login()"></p-button>

        <p-dialog [(visible)]="trocarSenhaDialog" [style]="{width: '450px'}" header="{{ 'login.reenviosenha' | translate }}" [modal]="true" styleClass="p-fluid">
            <p-toast></p-toast>
            <ng-template pTemplate="content">
                <div class="p-field">
                    <label for="name">{{ 'label.email' | translate }}</label>
                    <input type="text" pInputText id="codBanco" [(ngModel)]="loginRequest.username" required autofocus />
                </div>
            </ng-template>
            <ng-template pTemplate="footer">
                <button pButton pRipple label="{{ 'label.cancelar' | translate }}" icon="pi pi-times" class="p-button-text" (click)="hideDialog()" ></button>
                <button pButton pRipple label="{{ 'label.reenviar' | translate }}" icon="pi pi-check" class="p-button-text" (click)="resetPass()"></button>
            </ng-template>
        </p-dialog>

        <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

        </div>
    </div>
</div>
